// extracted by mini-css-extract-plugin
export default {"icon":"CoverIcon_icon__Z04vQ","placeholder":"CoverIcon_placeholder__50bUC"};